import { Button, styled } from "@mui/material";

const GButton = styled(Button)(({ variant }) => ({
  backgroundColor: variant === "text" ? "currentcolor" : undefined,
  textTransform: "none",
  backgroundImage: variant === "text" ? "linear-gradient(0deg, rgba(256,256,256,.9), rgba(256,256,256,.9))" : undefined,
  "&:hover": {
    backgroundColor: variant === "text" ? "currentcolor" : undefined,
    backgroundImage:
      variant === "text" ? "linear-gradient(0deg, rgba(256,256,256,.8), rgba(256,256,256,.8))" : undefined,
  },
}));

export default GButton;
